import {configureStore} from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import roomReducer from './slices/roomSlice';
import matchReducer from './slices/matchSlice';
import chatReducer from './slices/chatSlice';
import registrationReducer from './slices/registrationSlice';
import directMessageReducer from './slices/directMessageSlice';
import profileReducer from './slices/profileSlice';
import verificationReducer from './slices/verificationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    room: roomReducer,
    match: matchReducer,
    chat: chatReducer,
    registration: registrationReducer,
    directMessages: directMessageReducer,
    profile: profileReducer,
    verification: verificationReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
